if(adSpaceCount != 0) {
    const adContainer = document.querySelector("[data-ad]")
    const adButtons = document.querySelectorAll("[data-ad-btn]")
    const adItems = document.querySelectorAll("[data-ad-item]")
    const indicators = document.querySelector("[data-ad-indicator]").children
    const modals = document.querySelectorAll("[data-ad-modal]")
    const countdowns = document.querySelectorAll("[data-countdown]")
    var adIdx = 0
    let openModal
    var countDownDate = new Date("Jan 5, 2024 15:37:25").getTime()
    let cartJSON = getCartJSON()
    
    var timer = setInterval(countDownTimer, 1000)
    var autoScrolling = setInterval(nextItem, 20000)
    
    adContainer.addEventListener("mouseenter", () => {
        autoScrolling = clearInterval(autoScrolling)
    })
    
    adContainer.addEventListener("mouseleave", () => {
        autoScrolling = setInterval(nextItem, 20000)
    })
    
    adButtons.forEach(button => {
        button.addEventListener("click", () => {
            let bodyTemp = document.body
            let btnName = button.getAttribute("data-ad-btn")
            if(btnName === "close") {
                adContainer.classList.add("hidden")
            } else if(btnName === "modal-close") {
                let temp = document.querySelector("[data-ad-btn='close']")
                modals[openModal].classList.toggle("active-modal")
                temp.classList.toggle("hidden")
                bodyTemp.classList.toggle("no-scroll")
            } else if(btnName === "read-more") {
                openModal = adIdx
                let temp =document.querySelector("[data-ad-btn='close']")
                bodyTemp.classList.toggle("no-scroll")
                temp.classList.toggle("hidden")
                modals[adIdx].classList.toggle("active-modal")
            } else if(btnName === "next") {
                nextItem()
            } else if(btnName === "prev") {
                prevItem()
            } else if(btnName === "add-to-cart") {
                cartJSON = getCartJSON()
                let tempProductInfo
                cartJSON.items.forEach(item => {
                    if(item.id == parseInt(button.getAttribute("data-product-id"))) {
                        tempProductInfo = item
                    }
                })
    
                
                if(tempProductInfo == undefined) {
                    Shopify.addItem(parseInt(button.getAttribute("data-product-id")), parseInt(1))
                } else {
                    Shopify.changeItem(tempProductInfo.id, tempProductInfo.quantity + 1)
                }
                updateCart(1)
            }
        })
    })
    
    function nextItem() {
        indicators[adIdx].classList.toggle("active")
        adItems[adIdx].classList.toggle("active")
        if(adIdx < indicators.length - 1)
            adIdx++
        else 
            adIdx = 0
    
        indicators[adIdx].classList.toggle("active")
        adItems[adIdx].classList.toggle("active")
    }
    
    function prevItem() {
        indicators[adIdx].classList.toggle("active")
        adItems[adIdx].classList.toggle("active")
        if(adIdx > 0)
            adIdx--
        else
            adIdx = indicators.length - 1
    
        indicators[adIdx].classList.toggle("active")
        adItems[adIdx].classList.toggle("active")
    }
    
    Array.from(indicators).forEach((indicator, idx) => {
        indicator.addEventListener("click", () => {
            adIdx = idx;
            temp = document.querySelectorAll(".active")
            temp.forEach(item => {
                item.classList.remove("active")
            })
    
            indicator.classList.toggle("active")
            adItems[adIdx].classList.toggle("active")
        })
    })
    
    function countDownTimer() {
        let currentTime = new Date().getTime()
    
        let distance = countDownDate - currentTime
    
        let days = Math.floor(distance/(1000 * 60 * 60 * 24))
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        let seconds = Math.floor((distance % (1000 * 60)) / 1000)
    
        countdowns[adIdx].innerHTML = `Time remaining: ${days}d ${hours}h ${minutes}m ${seconds}s`
    
        if(distance < 0) {
            clearInterval(x);
            countdowns[adIdx].innerHTML = "EXPIRED"
        }
    }
    
    function updateCart(itemQuantity) {
        setTimeout(() => {
            cartCount += itemQuantity
            shoppingCartCounts.forEach(shoppingCartCount => {
                if(cartCount > 99)
                    shoppingCartCount.innerHTML = "99+"
                else
                    shoppingCartCount.innerHTML = cartCount
            })
            updateShoppingCartCount()
            $('[data-shopping-cart-content]').load(location.href+' [data-shopping-cart-content]>*',function() {
                updateShoppingCart()
            })
        }, 1000)
    }
}

